const GlobalPlugins : React.FC = () => {
    return <>

    </>
}

export default GlobalPlugins